import { faLocationCrosshairs } from '@fortawesome/free-solid-svg-icons';
import { StatusPage } from './statusPage.component';

// Catch-all for any URL that doesn't match a route at all — a mistyped/stale link,
// not a permission problem (see unAuthroizedAccess.page.jsx for that case). Before
// this existed the app had no catch-all route, so an unmatched URL rendered a blank
// white screen with no way back short of editing the address bar.
export const PageNotFound = ()=>{
    return(
        <StatusPage
            icon={faLocationCrosshairs}
            heading="Page not found"
            message="This page doesn't exist — the link may be out of date or mistyped. Head back to your dashboard and try again from there."
        />
    )
}
